/**
 * Configuration for the modern bike station popup.
 *
 * This file centralises the display variants and layout constants of the
 * new map-anchored popup. It is intended as a testing harness: change the
 * variant, reload the app, and once a choice is fixed the unused variants
 * and the legacy popup can be removed.
 */

export type BikeStationPopupVariant = "compact" | "detailed";

export interface BikeStationPopupConfig {

    /** Default modern popup style in production. */
    "useModernPopupByDefault": boolean;

    /** Display variant for the modern popup. */
    "variant": BikeStationPopupVariant;

    /** Whether to show the capacity fill ratio bar. */
    "showCapacityBar": boolean;

    /** Whether to show battery summary for ebikes. */
    "showBatterySummary": boolean;

    /** Max vehicles to render in the expanded ebike detail panel. */
    "maxVehicleListItems": number;

    /** Fixed popup width in px. */
    "fixedWidthPx": number;

    /** Margins for map-anchored positioning. */
    "margins": {
        "marginTop":    number;
        "marginRight":  number;
        "marginBottom": number;
        "marginLeft":   number;
    };

}

export const BIKE_STATION_POPUP_CONFIG: BikeStationPopupConfig = {
    "useModernPopupByDefault": true,
    "variant":                 "detailed",
    "showCapacityBar":         true,
    "showBatterySummary":      true,
    "maxVehicleListItems":     8,
    "fixedWidthPx":            275,
    "margins":                 {
        "marginTop":    200,
        "marginRight":  10,
        "marginBottom": 15,
        "marginLeft":   10,
    },
} as const;
